import React from 'react';

/**
 * Exam countdown timer with color changes at warning thresholds.
 * 30 min = yellow, 10 min = orange, 5 min = red.
 */
export default function ExamTimer({ seconds, isRunning }) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  const formatted = h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;

  let colorClass = 'text-gray-700';
  if (seconds <= 300) colorClass = 'text-red-600'; // 5 min
  else if (seconds <= 600) colorClass = 'text-orange-500'; // 10 min
  else if (seconds <= 1800) colorClass = 'text-yellow-600'; // 30 min

  return (
    <div className={`font-mono text-lg font-bold ${colorClass} ${!isRunning ? 'opacity-50' : ''}`}>
      {formatted}
    </div>
  );
}
